import React from "react";
import Rooms from "src/pages/Meetings/Rooms";
import MeetingTypes from "src/pages/Meetings/MeetingType";

import MeetingPanel from "src/pages/Meetings/Panel";
import MeetingPrint from "src/pages/Meetings/Panel/components/Print";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path ="/meeting/rooms" key="meetingrooms" exact component={Rooms} isPrivate/>,
	<RoutePrivate path ="/meeting/types" key="meetingtypes" exact component={MeetingTypes} isPrivate/>,
	<RoutePrivate path ="/meeting/panel" key="meetingpanel" exact component={MeetingPanel} isPrivate/>,
	<RoutePrivate path ="/meeting/panel/:meetingId" permissionPath ="/meeting/panel" key="meetingpanelMeetingId" exact component={MeetingPanel} isPrivate/>,
	<RoutePrivate path ="/meeting/print/:meetingId" permissionPath="/meeting/panel" key="meetingsPrint" exact component={MeetingPrint} isPrivate/>
];
